import type { FaireProductEntity } from "../../entity_types/product";

export const pom_pom_6: FaireProductEntity = {
  token: "pom-pom-6",
  type: "product",
  name: "Popcorn, Umami",
  brandName: "Pom Pom Popcorn by Bessou",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2f105d7914ad23ec8580913bd623aecbf7f9e4cc7ff90028f5ce4a21f356740b.webp",
  priceDollars: 10,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
